import { Button, DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutNewOffer extends Layout {
    buttonMakeOffer: Button;
    labelAdditionalDetails: Label;
    labelDeliveryDate: Label;
    labelDeliveryDateTZ: Label;
    labelDistance: Label;
    labelDistanceCaption: Label;
    labelDistanceUnits: Label;
    labelEmailConfirmation: Label;
    labelOfferRate: Label;
    labelPickupDate: Label;
    labelPickupDateTZ: Label;
    labelSuccess: Label;
    labelThisLoadIsNoLongerAvailable: Label;
    panelAdditionalDetails: Panel;
    panelAvailable: Panel;
    panelCommodityAndEquipment: Panel;
    panelDelivery: Panel;
    panelNotAvailable: Panel;
    panelPickup: Panel;
    panelSuccess: Panel;
    sourceCarrierAvailableOrders: DataSource;
    sourceCarrierNewOffer: DataSource;
    textboxCommodity: Textbox;
    textboxCounterAmount: Textbox;
    textboxDestinationLocation: Textbox;
    textboxEquipmentDescr: Textbox;
    textboxEquipmentLength: Textbox;
    textboxOrderId: Textbox;
    textboxOriginLocation: Textbox;
    textboxWeight: Textbox;
}
